import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  status: {
    display: 'inline-block',
    color: foundations.colors.gray400,
  },
});
